module.exports = __webpack_public_path__ + "static/img/etr_function_h5.11bd2e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/publicDetail/etr_function_h5.png
// module id = bfSe
// module chunks = 34